import React from "react";
import moment from "moment";
import RaisedButton from "components/common/material/RaisedButton";
import {replace} from "react-router-redux";
import * as FormatUtils from "utils/formatUtils";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import _get from "utils/get";
import CSSModules from "react-css-modules";
import * as cardActions from "./redux";
import NumberFormatter from "../utils/numberFormatter";
import GlanceBox from "../components/common/glanceBox/GlanceBox";
import styles from "./CardStatement.scss";
import LoadingBlocking from '../components/loading/LoadingBlocking';
import Transactions from "./transaction/transactions";
import {ACTION_STATUS_PENDING} from '../utils/redux/thunkActionConstants';
import {getMainCard, getSunbitCard4LastDigits, getAccount} from "./cardHelper";
import {injectIntl} from "react-intl";
import {FileFormat} from "../services/api/dto/fileFormat";

@connect(
  state => ({
    card: state.card
  }),
  dispatch => ({
    goToMakeAPayment: () => dispatch(replace("/card/payment")),
    getBalance: () => dispatch(cardActions.getBalance()),
    getTransactionsByDate: (data ) => dispatch(cardActions.getTransactionsByDate(data)),          // get transaction by the DD
    getDdTransactionsList: () => dispatch(cardActions.getDdTransactionsList()),          // dd list
    getStatement: statementDate => dispatch(cardActions.getStatement(statementDate)),
    getPendingAndCurrentTransactions: () => dispatch(cardActions.getPendingAndCurrentTransactions()),
  })
)
@injectIntl
@CSSModules(styles, {allowMultiple: true})
class CardController extends React.Component {
  ddDefaultId = 0; // default value for Transactions dd list

  static propTypes = {
    card: PropTypes.object,
    routeParams: PropTypes.object,
    getCardAccount: PropTypes.func,
    getBalance: PropTypes.func,
    getStatement: PropTypes.func,
    getTransactionsByDate: PropTypes.func,
    goToMakeAPayment: PropTypes.func,
    getDdTransactionsList: PropTypes.func,
    getPendingAndCurrentTransactions: PropTypes.func,
    isCardImageUriLoaded: PropTypes.bool,
    cardImageUri: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {pickedTransactionDd: this.ddDefaultId ,
                  isLoading : false,
                  transactions : [],           // transactions to render
                  allTransaction : [],         // the first balk of transactions (before user click DD)
                  pendingTransactions : [],
                  transactionsHistory : {},    // save all the history user search and prevent double call to server
                  ddTransactionsList : [],
                  pdfDownloadList : {}};
  }

  componentDidMount() {
    this.props.getBalance();
    this.props.getStatement();
    this.props.getDdTransactionsList();
    this.props.getPendingAndCurrentTransactions();
  }

  getLastStatement(statement) {
    return statement[Object.keys(statement)[0]];
  }

  renderStatement() {
    const statement = _get(this, ["props", "card", "statement"]);
    const balance = _get(this, ["props", "card", "balance"], null);
    const account = getAccount(this.props);
    const accountAmortizationInMonth = _get(account, ['amortization', 'unit']) === "TERM_IN_MONTHS" ? account.amortization.value : null;

    if (!balance && !statement) {
        return (<div styleName="content center">
          <span>Please allow up to 72 hours for your account details to be displayed.</span>
        </div>);
    } else if (balance && !statement) {
      return (
        <div styleName="content center">
          <span>Your first statement will close on&nbsp;</span>
          <span>
            <b data-at="statement-box-next-cycle-date">
              {moment(balance.nextCycleDate).format("MM/DD/YYYY")}
            </b>
          </span>
          <span>.</span>
        </div>
      );
    } else if (balance && statement) {
      const lastStatement = this.getLastStatement(statement);
      return (
        <div styleName="statement">
          <div styleName="statement-content">
            <div styleName="statementTable">
              <div styleName="statementRow">
                <div
                  styleName="title"
                  data-at="closing-statement-balance-title"
                >
                  Closing Statement Balance
                </div>
                <div styleName="filler"/>
                <div styleName="sum" data-at="closing-statement-balance-value">
                  {NumberFormatter.getCurrencyFormattedNumber(
                    lastStatement.statementEndingBalance
                  )}
                </div>
              </div>

              <div styleName="statementRow">
                <div
                  styleName="title"
                  data-at="remaining-statement-balance-title"
                >
                  Remaining Statement Balance
                </div>
                <div styleName="filler"/>
                <div styleName="sum" data-at="remaining-statement-balance-value">
                  {NumberFormatter.getCurrencyFormattedNumber(
                    balance.remainingStatementBalance
                  )}
                </div>
              </div>

              <div styleName="statementRow">
                <div styleName="title" data-at="min-payment-due-title">
                  Minimum Payment Due
                </div>
                <div styleName="filler"/>
                <div styleName="sum" data-at="min-payment-due-value">
                  {NumberFormatter.getCurrencyFormattedNumber(
                    balance.currentMinimumPaymentDueAmount
                  )}
                </div>
              </div>
            </div>
          </div>
          <div styleName="payment-content">
            <span styleName="bold" data-at="payment-due-date-title">
              Due Date:&nbsp;
            </span>{" "}
            <span data-at="payment-due-date-value">
              {moment(lastStatement.paymentDueDate).format("MM/DD/YYYY")}
            </span>
            <div styleName="makeAPaymentBtn">
              <RaisedButton
                onClick={this.props.goToMakeAPayment}
                data-at="pay-button">
                Pay
              </RaisedButton>
            </div>
          </div>
          {accountAmortizationInMonth && <div styleName="disclaimer" data-at="disclaimer-1-text">
            Based on a {accountAmortizationInMonth}-month plan.
          </div>}
          <div styleName="disclaimer" data-at="disclaimer-2-text">
            Please allow 24-48 hours for recent activity to be displayed and
            reflected in your current balance.
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderBalance() {
    const balance = _get(this, ["props", "card", "balance"], null);
    if (!balance) {
      return null;
    }
    return (
        <div styleName="balanceContent">
          <div styleName="balanceContentContainer">
           <span styleName="balanceContentTitle" data-at="balance-box-current-balance">
             Current Balance: {FormatUtils.addPriceSymbol(balance.currentBalanceAmount)}
           </span>
          </div>
          <div styleName="availableCredit" data-at="balance-available-credit">
            Available Credit: {FormatUtils.addPriceSymbol(balance.availableCreditAmount)}
          </div>
        </div>
    );
  }

  transactionHeaderDdOnChange = (willBeDdData) => {
    // ddData = the value of the ddTransaction => value is the same as the index in order to do it O1
      const { ddTransactionsList , transactionsHistory , pickedTransactionDd , pendingTransactions , allTransaction } = this.state;
      let isLoading = false;
      if (willBeDdData !== pickedTransactionDd) { // if the user click the same dd
                  ddTransactionsList[willBeDdData].disabled = true;
                  ddTransactionsList[pickedTransactionDd].disabled = false;
                  if ((transactionsHistory[willBeDdData] === null || transactionsHistory[willBeDdData] === undefined) && willBeDdData !== null) {
                       // if data aren't exist
                       const pickedDate = ddTransactionsList[willBeDdData].original;
                       this.props.getTransactionsByDate(pickedDate);
                       isLoading= true;
                       this.handleSetStateData([], ddTransactionsList, willBeDdData, pendingTransactions, allTransaction, isLoading, {});
                     }
                  else  {
                    const whatToRender =  transactionsHistory[willBeDdData] ? transactionsHistory[willBeDdData].statementTransactions : allTransaction;
                    const statement    =  transactionsHistory[willBeDdData] ? transactionsHistory[willBeDdData].statement : {};
                    this.handleSetStateData(whatToRender, ddTransactionsList, willBeDdData, pendingTransactions, allTransaction, isLoading ,statement);
                  }
       }
  };

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.card !== prevProps.card ) {
      const transactionsByDate  = _get(this, ["props", "card", "transactionsByDate"], {statement : {},  statementTransactions: [], sumTransactionAmount: undefined, supplementalDoc: {}});
      const ddTransactionsList  = _get(this, ["props", "card", "ddTransactionsList"], []);
      const postTransactions    = _get(this, ["props", "card", "currentTransactions"], []);
      const pendingTransactions = _get(this, ["props", "card", "pendingTransactions"], []);
      const isLoading = this.props.card.status === ACTION_STATUS_PENDING;
      const whatToRender  = transactionsByDate.statementTransactions && this.state.pickedTransactionDd !== this.ddDefaultId ? transactionsByDate.statementTransactions : postTransactions;
      const statement     = transactionsByDate.statement && this.state.pickedTransactionDd !== this.ddDefaultId ? transactionsByDate.statement : {};
      this.handleSetStateData(whatToRender, ddTransactionsList , this.state.pickedTransactionDd , pendingTransactions ,
        postTransactions , isLoading , statement, transactionsByDate.sumTransactionAmount, transactionsByDate.supplementalDoc);
    }
  }

  handleSetStateData = (whatToRender , ddTransactionsList , pickedTransactionDd, pendingTransactions , allTransactions ,
                        isLoading = false , statement = {}, sumTransactionAmount, supplementalDoc) => {
    // manage the state update
    const transactionHistory  = {[pickedTransactionDd] :{statementTransactions : whatToRender ? whatToRender : [] ,
                                                         statement : statement ? statement : {},
                                                         sumTransactionAmount: sumTransactionAmount,
                                                         supplementalDoc: supplementalDoc}};

    this.setState({ isLoading : isLoading,
                          pickedTransactionDd : pickedTransactionDd,
                          transactions : whatToRender ,
                          pendingTransactions : pendingTransactions,
                          allTransaction : allTransactions,
                          transactionsHistory : { ...this.state.transactionsHistory ,...transactionHistory},
                          ddTransactionsList : ddTransactionsList});
  };

  renderPlasticCard = (last4Digits, element) => {
    const canvas = element;
    if(canvas && this.props.isCardImageUriLoaded) {
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.src = this.props.cardImageUri;
      img.onload = function() {
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
        ctx.font = '14px Roboto';
        ctx.fillStyle = "white";
        ctx.fillText(`${last4Digits}`, 15, canvas.height-15);
      };
    }
  };

  render() {
    const {
      intl: { formatMessage }
    } = this.props;
    const {pickedTransactionDd , transactions , ddTransactionsList , isLoading , pendingTransactions } = this.state;
    const isPickedTransaction = pickedTransactionDd !== null && _get(this, ["state", `transactionsHistory`,pickedTransactionDd,"statement","statementFileExist"], false);
    const date = isPickedTransaction ?  ddTransactionsList[pickedTransactionDd].original : "";
    // const isPendingTransactionFlagOn = CardUtils.isFeatureFlagEnabled("PendingTransaction" ,_get(this, ["props", "card", "balance" ,"cardAccountId"], 0));
    const titlePending =  "Pending Transactions" ;
    const titlePosted =  "Statement Date" ;
    const statementsUrl = [
      {
        fileFormat: FileFormat.PDF,
        url: `/transactions-pdf/file-date/${date}`,
        visible: true
      },
      {
        fileFormat: FileFormat.HTML,
        url: `/transactions-html/file-date/${date}`,
        visible: true
      }
    ];
    const mainCard = getMainCard(_get(this.props, ["card", "card", "cards"], []));
    const last4Digits = getSunbitCard4LastDigits(mainCard);
    return (
      <div styleName="cardStatementContainer">
        {this.renderBalance()}

        <div styleName="balanceAndStatementBoxes">
          {
            <div className={styles.cardPlasticImageContainer}>
              <div className={styles.cardPlasticImage}>
                <input value={last4Digits} data-at="card-image-last-4-digits" type="hidden"/>
                <canvas ref={this.renderPlasticCard.bind(this, last4Digits)}/>
              </div>
            </div>
          }

          <div styleName="statementGlanceBox">
            <GlanceBox title={"Last Statement"}
                       dataAt={"last-statement"}
                       color={"green"}
                       styles={styles}>
              {this.renderStatement()}
            </GlanceBox>
          </div>
        </div>

        <div styleName="transactionSection">
          {isLoading && <LoadingBlocking />}
          <Transactions title={titlePending}
                        transactionHeaderDdOnChange={null}
                        pickedTransactionDd={pickedTransactionDd}
                        ddTransactionsList={null}
                        transactions={pendingTransactions}/>
          <Transactions title={titlePosted}
                        statementsUrl={statementsUrl}
                        rightTitle= {isPickedTransaction ?  formatMessage({id: "card.statement.viewStatements"}) : ""}
                        isPickedTransaction={isPickedTransaction}
                        onRightTitleClick={() => ''}
                        transactionHeaderDdOnChange={this.transactionHeaderDdOnChange}
                        pickedTransactionDd={pickedTransactionDd}
                        ddTransactionsList={ddTransactionsList}
                        transactions={transactions}/>
        </div>
      </div>
    );
  }
}

export default CardController;



// WEBPACK FOOTER //
// ./src/card/CardStatement.js